import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SuperadminHeader } from "../components/superadmin/SuperadminHeader";

export const Route = createFileRoute("/superadmin/feature-flags")({
  component: SuperadminFeatureFlagsLayout,
});

function SuperadminFeatureFlagsLayout() {
  return (
    <div className="flex h-screen flex-col bg-background">
      <SuperadminHeader
        title="Feature Flags"
        subtitle="Manage feature rollouts"
      />

      {/* Content - renders child routes */}
      <main className="flex-1 overflow-auto p-6">
        <div className="container mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
